module.exports = __webpack_public_path__ + "img/las-logo-header.232cc5d4.png";